<template>
  <div class="preferenze">
    <button id="btn-preferenze" class="btn btn-primary" @click="showPreferences()">
      <font-awesome-icon icon="cookie" />
      Preferenze
    </button>

    <div class="modal modal-fullscreen-md-down" id="modal" data-bs-backdrop="static" data-bs-keyboard="false"
      tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content ">
          <div class="modal-header">
            <h2 class="modal-title" id="modalLabel">Informativa cookies</h2>
            <button id="btnChiudiModal" type="button"
                    class="btn-modal-close" aria-label="Close"
                    @click="closeModal()">
            </button>
          </div>
          <div class="modal-body">
            <div id="defaultBody">
              Questo sito Web utilizza i cookie per personalizzare l’esperienza di navigazione. I cookie che sono
              classificati come necessari vengono memorizzati sul browser dell’Utente in quanto essenziali per
              l’abilitazione delle
              funzionalità di base. Il Sito si serve inoltre di cookie e altre tecnologie per garantire l’affidabilità
              dello stesso Sito, misurarne le performance, fornire un’esperienza personalizzata e contenuti commerciali
              e
              annunci
              personalizzati. Questi cookie vengono memorizzati nel browser dell’Utente solo con il suo consenso come
              descritto nella nostra <a href="/cookie-policy.html">cookie-policy</a> La chiusura di questo banner,
              mediante il simbolo X
              in alto a destra, comporta l'applicazione delle impostazioni di default e dunque la continuazione della
              navigazione in assenza di cookie o altri strumenti di tracciamento diversi da quelli tecnici.
            </div>
            <div id="secondBody">
              <form id="form-preferenze" action="/cookieconsent.php" method="post">
                <table id="tablePreferenze">
                  <thead>
                    <tr>
                      <td class="btnChangeModal"><button type="button" class="btn-modal-back filter-white"
                          aria-label="Close"></button></td>
                      <th>Preferenze</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th @click="showDesc('tipo1', 'descrizione1')" class="th-preferenze" id="tipo1">Cookie
                        Strettamente
                        Necessari (Tecnici)</th>
                      <td class="td-preferenze">
                        <input name="tecnici" type="checkbox" style="display: none;" class="checkbox-cookie"
                          checked />
                        <label class="preferenzeSwitch">
                          <input type="checkbox" class="checkbox-cookie" checked disabled />
                          <span class="preferenzeSlider round"></span>
                        </label>
                        <p id="descrizione1">
                          Questi cookie sono necessari al funzionamento del Sito e non possono essere disattivati. Di
                          solito essi sono installati solo a seguito di azioni intraprese dall’Utente che possano
                          qualificarsi come richiesta di
                          servizi, quali ad esempio impostare le Sue preferenze sulla privacy, effettuare il login o
                          compilare moduli. È possibile impostare il browser in modo tale che esso blocchi tali cookie o
                          invii una notifica circa la
                          loro esistenza, ma alcune parti del Sito non saranno funzionanti. Questi cookie non conservano
                          alcun dato personale e il loro utilizzo non richiede il consenso dell’Utente.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th @click="showDesc('tipo2', 'descrizione2')" class="th-preferenze" id="tipo2">Cookie di
                        Performanza e Analitici</th>
                      <td class="td-preferenze">
                        <label class="preferenzeSwitch">
                          <input name="analytics" type="checkbox" class="checkbox-cookie" checked disabled />
                          <span class="preferenzeSlider round"></span>
                        </label>
                        <p id="descrizione2">
                          Questi cookie consentono di conteggiare le visite e di determinare le fonti del traffico, così
                          da poter misurare e migliorare la performance del Sito. Aiutano a capire quanti Utenti passano
                          sul Sito. Tutte le
                          informazioni raccolte da questi cookie sono in forma aggregata e dunque anonima. Questi cookie
                          non conservano alcun dato personale e il loro utilizzo non richiede il consenso dell’Utente.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th @click="showDesc('tipo3', 'descrizione3')" class="th-preferenze" id="tipo3">Cookie di
                        Profilazione</th>
                      <td class="td-preferenze">
                        <label class="preferenzeSwitch">
                          <input name="profilazione" v-bind:value="preferences.profilazione"
                                true-value=1 false-value=0 v-model="preferences.profilazione"
                                type="checkbox" class="checkbox-cookie" checked/>
                          <span class="preferenzeSlider round"></span>
                        </label>
                        <p id="descrizione3">
                          Questi cookie possono essere inseriti nel Sito da partner pubblicitari. Potrebbero essere
                          utilizzati da queste società per elaborare un profilo degli interessi dell’Utente e mostrare
                          annunci rilevanti su altri
                          siti. Non sono conservati direttamente informazioni personali ma il loro funzionamento è
                          basato
                          sull’identificazione univoca del browser dell’Utente e dispositivo di navigazione su internet.
                          Per i cookie di
                          profilazione è necessario il consenso dell’Utente.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th @click="showDesc('tipo4', 'descrizione4')" class="th-preferenze" id="tipo3">Cookie di
                        Funzionalità</th>
                      <td class="td-preferenze">
                        <label class="preferenzeSwitch">
                          <input name="funzionalità" v-bind:value="preferences.funzionalità"
                                true-value=1 false-value=0 v-model="preferences.funzionalità"
                                type="checkbox" class="checkbox-cookie" checked />
                          <span class="preferenzeSlider round"></span>
                        </label>
                        <p id="descrizione4">
                          Questi cookie rendono possibile la personalizzazione del Sito riconoscendo gli Utenti e
                          ricordando le loro preferenze. Possono essere create dal Titolare del trattamento o da
                          fornitori
                          terzi. Per i cookie di
                          funzionalità è necessario il consenso dell’Utente.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <div id="defaultFooter">
              <!-- <button type="button" class="btnChangeModal btn-modal btn-modal-secondary">Preferenze</button> -->
            </div>
            <button id="btnAccettaTutti" type="button" class="btn-modal btn-modal-primary" @click="acceptAll()">
              Accetta tutti
              </button>
            <div id="secondFooter">
              <button id="btnAccettaSel" type="button" class="btn-modal btn-modal-secondary" @click="acceptSelected()">
              Accetta selezionati
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="preferenzeModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="modalLabel">Informativa cookies</h2>
            <button id="btnChiudiPreferenze" @click="closePreferences()" type="button" class="btn-modal-close"
              aria-label="Close"></button>
          </div>
          <form id="preferences-form" class="modal-body">
            <table>
              <thead>
                <tr>
                  <th>Impostazioni di personalizzazione e cookie</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Cookie tecnici</th>
                  <td>
                    <label class="preferenzeSwitch">
                      <input name="tecnici" class="checkbox-cookie-pref" type="checkbox" checked disabled />
                      <span class="preferenzeSlider round"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <th>Cookie di Performanza e Analitici</th>
                  <td>
                    <label class="preferenzeSwitch">
                      <input name="analytics" class="checkbox-cookie-pref" type="checkbox" checked disabled />
                      <span class="preferenzeSlider round"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <th>Cookie di Profilazione</th>
                  <td>
                    <label class="preferenzeSwitch">
                      <input name="profilazione" v-bind:value="preferences.profilazione" v-model="preferences.profilazione"
                              false-value=0 true-value=1 class="checkbox-cookie-pref" type="checkbox" checked />
                      <span class="preferenzeSlider round"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <th>Cookie di Funzionalità</th>
                  <td>
                    <label class="preferenzeSwitch">
                      <input name="funzionalità" v-bind:value="preferences.funzionalità" v-model="preferences.funzionalità"
                              false-value=0 true-value=1 class="checkbox-cookie-pref" type="checkbox" checked />
                      <span class="preferenzeSlider round"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
          <div class="modal-footer">
            <button id="btnAccettaSelezionatiPreferenze" @click="acceptSelected()" type="button"
              class="btn-modal btn-modal-secondary">Accetta selezionati</button>
            <button id="btnAccettaTuttiPreferenze" @click="acceptAll()" type="button"
              class="btn-modal btn-modal-primary">Accetta tutti</button>
          </div>
        </div>
      </div>
    </div>
    <div id="containerPreferenze"></div>
  </div>
</template>

<script>
import service from '../services/service';
import utils from '../services/utils.js';

const COOKIE_NAME = 'agreed';
const COOKIE_DAYS = 365;

export default {
  name: 'preferenze',
  data() {
    return {
      preferences: {
        tecnici: "1",
        analytics: "1",
        profilazione: "1",
        funzionalità: "1"
     },
      PREFERENCESALL: {
        tecnici: "1",
        analytics: "1",
        profilazione: "1",
        funzionalità: "1"
     },
      PREFERENCESNECESSARY: {
          tecnici: "1",
          analytics: "1",
          profilazione: "0",
          funzionalità: "0"
      },
    }
  },
  mounted() {
    let cookie = utils.getCookie(COOKIE_NAME);
    if (cookie === "")
      this.showModal();
    else {
      this.preferences = JSON.parse(cookie);
    }
  },

  methods: {
    showModal() {
      document.getElementById('modal').style.display = "block";
    },

    async closeModal() {
      document.getElementById('modal').style.display = "none";
      if (!utils.getCookie(COOKIE_NAME)) {
        utils.setCookie(COOKIE_NAME, JSON.stringify(this.PREFERENCESNECESSARY), COOKIE_DAYS);
        await service.execute("post", "privacy/consent", { agreed: JSON.stringify(this.PREFERENCESNECESSARY) });
      }
    },

    showPreferences() {
      document.getElementById('preferenzeModal').style.display = "block";
    },

    closePreferences() {
      document.getElementById('preferenzeModal').style.display = "none";
    },

    async acceptSelected() { 
      utils.setCookie(COOKIE_NAME, JSON.stringify(this.preferences), COOKIE_DAYS);
      document.getElementById('modal').style.display = "none";
      document.getElementById('preferenzeModal').style.display = "none";
      await service.execute("post", "privacy/consent", { agreed: JSON.stringify(this.preferences) })
    },

    async acceptAll() {
      utils.setCookie(COOKIE_NAME, JSON.stringify(this.PREFERENCESALL), COOKIE_DAYS);
      document.getElementById('modal').style.display = "none";
      document.getElementById('preferenzeModal').style.display = "none";
      await service.execute("post", "privacy/consent", { agreed: JSON.stringify(this.PREFERENCESALL) })
    },

    showDesc(tipo, descrizione) {
      var y = document.getElementById(tipo);
      var x = document.getElementById(descrizione);
      if (x.style.display == "") {
        x.style.display = "block";
        y.style.backgroundColor = "#4993ff";
        y.style.transition = "background-color 0.4s";
      } else {
        x.style.display = ""
        y.style.backgroundColor = "#0a58ca";
        y.style.transition = "background-color 0.4s";
      }
    },
  }
}
</script>

<style>
/* ho tentato di rifattorizzare... lascia perdere */
#btn-preferenze {
  color: rgb(255, 255, 255, 0.5);
  background-color: rgb(0, 0, 0, 0);
  border-color: rgb(0, 0, 0, 0);
}

:root {
  --ccolor0: #000;
  --ccolor1: #0a58ca;
  --ccolor2: #0d6efd;
  --ccolor3: #0b5ed7;
  --ccolor4: #2196f3;
  --ccolor5: #83c2f5;
  --ccolor6: #fff;
  --ccolor7: #dee2e6;
  --ccolor8: #ddd;
  --ccolor9: #f2f2f2;
  --ccolor10: #0a53be;
  --ccolor11: #616161;
  --ccolor12: #8a8a8a;
}

footer {
  min-height: calc(30% + 2px);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  z-index: 1041;
  font-family: "Open Sans";
  background: rgba(0, 0, 0, 0.4);
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  padding-top: 2rem;
  pointer-events: none;
}

.modal .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: var(--ccolor6);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.2rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--ccolor0);
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 0rem 1rem;
  border-bottom: 1px solid var(--ccolor7);
  border-top-left-radius: calc(0.2rem - 1px);
  border-top-right-radius: calc(0.2rem - 1px);
}

.modal-header h2 {
  display: block !important;
  font-size: 1.5em !important;
  margin-block-start: 0.2rem !important;
  margin-block-end: 0.2rem !important;
  margin-inline-start: 0px !important;
  margin-inline-end: 0px !important;
  font-weight: bold !important;
}

.modal-title {
  color: var(--ccolor1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  line-height: 1.5;
  text-transform: uppercase;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
  text-align: justify;
  font-size: 12px;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-evenly;
  padding: 0.75rem;
  border-top: 1px solid var(--ccolor7);
  border-bottom-right-radius: calc(0.2rem - 1px);
  border-bottom-left-radius: calc(0.2rem - 1px);
}

.modal-footer>* {
  margin: 0.25rem;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }

  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    margin: 0;
  }

  .modal-fullscreen-sm-down .modal-content {
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    margin: 0;
  }

  .modal-fullscreen-md-down .modal-content {
    border: 0;
    border-radius: 0;
    margin-top: 1rem;
  }

  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    margin: 0;
  }

  .modal-fullscreen-lg-down .modal-content {
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    margin: 0;
  }

  .modal-fullscreen-xl-down .modal-content {
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    margin: 0;
  }

  .modal-fullscreen-xxl-down .modal-content {
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }

  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}

.btn-modal {
  text-transform: uppercase;
  font-family: "Open Sans";
  display: inline-block;
  font-weight: 400;
  line-height: 1;
  color: #212529;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.3rem 0.7rem;
  font-size: 1rem;
  border-radius: 0.15rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn-modal {
    transition: none;
  }
}

.btn-modal:hover {
  color: var(--ccolor0);
}

.btn-modal-check:focus+.btn-modal,
.btn-modal:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.btn-modal-primary {
  color: var(--ccolor6);
  background-color: var(--ccolor2);
  border-color: var(--ccolor2);
}

.btn-modal-primary:hover {
  color: var(--ccolor6);
  background-color: var(--ccolor3);
  border-color: var(--ccolor1);
}

.btn-modal-check:focus+.btn-modal-primary,
.btn-modal-primary:focus {
  color: var(--ccolor6);
  background-color: var(--ccolor3);
  border-color: var(--ccolor1);
  box-shadow: 0 0 0 0.25rem rgba(49, 132, 253, 0.5);
}

.btn-modal-check:checked+.btn-modal-primary,
.btn-modal-check:active+.btn-modal-primary,
.btn-modal-primary:active,
.btn-modal-primary.active {
  color: var(--ccolor6);
  background-color: var(--ccolor1);
  border-color: var(--ccolor10);
}

.btn-modal-check:checked+.btn-modal-primary:focus,
.btn-modal-check:active+.btn-modal-primary:focus,
.btn-modal-primary:active:focus,
.btn-modal-primary.active:focus,
.show>.btn-modal-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.25rem rgba(49, 132, 253, 0.5);
}

.btn-modal-secondary {
  color: var(--ccolor6);
  background-color: var(--ccolor12);
  border-color: var(--ccolor12);
}

.btn-modal-secondary:hover {
  color: var(--ccolor6);
  background-color: var(--ccolor11);
  border-color: var(--ccolor11);
}

.btn-modal-check:focus+.btn-modal-secondary,
.btn-modal-secondary:focus {
  color: var(--ccolor6);
  background-color: var(--ccolor11);
  border-color: var(--ccolor11);
  box-shadow: 0 0 0 0.25rem rgba(20, 20, 20, 0.5);
}

.btn-modal-secondary:active,
.btn-modal-secondary.active {
  color: var(--ccolor6);
  background-color: var(--ccolor11);
  border-color: var(--ccolor11);
}

.btn-modal-secondary:focus,
.btn-modal-secondary:focus,
.btn-modal-secondary:active:focus,
.btn-modal-secondary.active:focus,
.show>.btn-modal-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.25rem rgba(54, 54, 54, 0.5);
}

.btn-modal-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--ccolor0);
  background: transparent url("../assets/btnclose.svg") center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.4;
}

.btn-modal-close:hover {
  opacity: 1;
  cursor: pointer;
}

.btn-modal-back {
  box-sizing: content-box;
  width: 0.5rem;
  height: 1rem;
  margin-left: 3px;
  background: url("../assets/btnback.svg") center/3em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 1;
}

.filter-white {
  filter: invert(100%);
}

.btn-modal-back:hover {
  text-decoration: none;
  opacity: 0.5;
  cursor: pointer;
}

.btn-modal-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  opacity: 1;
}

.btn-modal-close:disabled,
.btn-modal-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  opacity: 0.05;
}

.modal-header .btn-modal-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-body thead {
  text-align: left;
  font-size: 1rem;
  font-family: "OpenSans-bold";
}

.modal-body thead th {
  text-align: left;
  font-size: 1rem;
  font-family: "OpenSans-bold";
}

.modal-body th {
  text-align: left;
  font-size: 0.7rem;
  font-family: "OpenSans-bold";
}

.modal-body td {
  font-size: 0.5rem;
  font-family: "OpenSans-regular";
}

.preferenzeSwitch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 26px;
}

.preferenzeSwitch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.preferenzeSlider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--ccolor8);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.preferenzeSlider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: var(--ccolor6);
  -webkit-transition: 0.6s;
  transition: 0.6s;
}

input:checked+.preferenzeSlider {
  background-color: var(--ccolor4);
}

input:disabled:checked+.preferenzeSlider {
  background-color: var(--ccolor5);
}

input:focus+.preferenzeSlider {
  box-shadow: 0 0 1px var(--ccolor8);
}

input:checked+.preferenzeSlider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.preferenzeSlider.round {
  border-radius: 34px;
}

.preferenzeSlider.round:before {
  border-radius: 50%;
}

#tablePreferenze {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border: solid var(--ccolor6);
}

#tablePreferenze td,
#tablePreferenze th {
  padding: 8px;
  border: solid var(--ccolor6);
  font-size: 12px;
}

#tablePreferenze tr {
  background-color: var(--ccolor9);
}

#tablePreferenze tr:hover {
  background-color: var(--ccolor8);
}

#tablePreferenze th {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  background-color: var(--ccolor1);
  color: var(--ccolor6);
}

#tablePreferenze tbody th {
  vertical-align: top;
}

#tablePreferenze tbody th:hover {
  cursor: pointer;
}

#tablePreferenze tbody p {
  display: none;
  text-align: justify;
  font-size: 10px;
}

#tablePreferenze thead td {
  border-top-left-radius: 0.5rem;
  background-color: var(--ccolor1);
  width: 5%;
}

#tablePreferenze thead th {
  border-top-right-radius: 0.5rem;
}

.btnChangeModal:hover {
  cursor: pointer;
}

.btnChangeModal:hover>.btn-modal-back {
  text-decoration: none;
  opacity: 0.8;
}

.td-preferenze {
  text-align: right;
}

#modal {
  display: none;
}

#preferenzeModal {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Preferenze.vue